const initialState = {
	hasError: 0
};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//	REVIEW RECORD
		// ===================================
		case "REVIEW_RECORD_IS_LOADING":
			return {
				...getBasicStateRecord(state),
				recordIsLoading: 1
			};
		case "REVIEW_RECORD_HAS_ERROR":
			return {
				...state,
				recordIsLoading: 0,
				errorRecord: action.error
			};
		case "REVIEW_RECORD_SUCCESS":
			return {
				...state,
				reviewRecord: action.data.data,
				recordIsLoading: 0
			};

		// ===================================
		//	ALL
		// ===================================
		case "REVIEWS_ARE_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "REVIEWS_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				hasError: 1,
				error: action.error
			};
		case "REVIEWS_SUCCESS":
			return {
				...state,
				reviews: action.data.data,
				isLoading: 0
			};
		case "REVIEWS_RESET_STATE":
			const { isLoading, reviews, ...newState } = state;
			return {
				...newState
			};

		// ===================================
		//	SIGNED UP (ON-SITE)
		// ===================================
		case "SIGNED_UP_REVIEWS_ARE_LOADING":
			return {
				...getBasicStateRecord(state),
				signedUpReviewsIsLoading: 1
			};
		case "SIGNED_UP_REVIEWS_HAS_ERROR":
			return {
				...state,
				signedUpReviewsIsLoading: 0,
				signedUpError: action.error
			};
		case "SIGNED_UP_REVIEWS_SUCCESS":
			return {
				...state,
				signedUpReviews: action.data.data,
				signedUpReviewsIsLoading: 0
			};

		// ===================================
		//	RELATED
		// ===================================
		case "RELATED_REVIEWS_ARE_LOADING":
			return {
				...getBasicStateRelated(state),
				relatedIsLoading: 1
			};
		case "RELATED_REVIEWS_HAS_ERROR":
			return {
				...state,
				relatedIsLoading: 0,
				relatedError: action.error
			};
		case "RELATED_REVIEWS_SUCCESS":
			return {
				...state,
				relatedReviews: action.data.data,
				relatedIsLoading: 0
			};

		// ===================================
		//	BOTH RELATED AND ALL REVIEWS SUPPLIED
		// ===================================
		case "RELATED_AND_ALL_REVIEWS_SUCCESS":
			return {
				...state,
				relatedIsLoading: 0,
				reviews: action.all,
				relatedReviews: action.related
			};

		// ===================================
		//	PAST
		// ===================================
		case "PAST_REVIEWS_ARE_LOADING":
			return {
				...getBasicStatePast(state),
				pastIsLoading: 1
			};
		case "PAST_REVIEWS_HAS_ERROR":
			return {
				...state,
				pastIsLoading: 0,
				pastError: action.error
			};
		case "PAST_REVIEWS_SUCCESS":
			return {
				...state,
				pastReviews: action.data.data,
				pastIsLoading: 0
			};

		// ===================================
		//	DATE RANGE
		// ===================================
		case "REVIEWS_DATE_RANGE_ARE_LOADING":
			return {
				...getBasicStatePast(state),
				dateRangeIsLoading: 1
			};
		case "REVIEWS_DATE_RANGE_HAS_ERROR":
			return {
				...state,
				dateRangeIsLoading: 0,
				dateRangeError: action.error
			};
		case "REVIEWS_DATE_RANGE_SUCCESS":
			return {
				...state,
				dateRangeIsLoading: 0,
				dateRangeReviews: action.data.data
			};

		// ===================================
		//  DOCUMENTS
		// ===================================
		case "UPDATE_REVIEW_DOCUMENTS":
			return {
				...state,
				reviewRecord: {
					...state.reviewRecord,
					documents: action.documents
				}
			};

		default:
			return state;
	}
};

/**
 * Returns only the basic necessity of state without all of the errors, success, etc.
 * @param object state
 */
function getBasicStateRecord(state) {
	const { errorRecord, ...newState } = state;
	return newState;
}

function getBasicStateRelated(state) {
	const { error, success, ...newState } = state;
	return newState;
}

function getBasicStatePast(state) {
	const { errorPast, ...newState } = state;
	return newState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/reviews.js